// =============================================================================
// Re-order button — placeholder. Used by /orders.html (per-row .btn--pill)
// and /order.html (single big CTA in the order-detail head).
//
// Order id resolution: data-order-id on the button itself, falling back to
// the closest ancestor that carries it (.js-orderRow on /orders, .order-detail
// on /order).
// =============================================================================
(function ($) {
    'use strict';

    $(document).on('click', '.js-reorder', function (e) {
        e.preventDefault();

        const $btn = $(this);
        if ($btn.hasClass('btn--loading')) { return; }

        const orderId = $btn.attr('data-order-id')
            || $btn.closest('[data-order-id]').attr('data-order-id')
            || '';

        $btn.addClass('btn--loading').prop('disabled', true);

        // TODO: replace this 600ms placeholder with a real backend call when
        // /cart/reorder.html exists:
        //
        //   $.ajax({
        //       method: 'POST',
        //       url: '/cart/reorder.html',
        //       data: { order_id: orderId },
        //       dataType: 'json',
        //   })
        //       .done((res) => {
        //           if (res && (res.cart || res.cart === 0)) { $('.cart-count').text(res.cart); }
        //           if (window.notyf) { window.notyf.success(res?.msg || 'Items added to your cart.'); }
        //           if (res && res.redirect) { setTimeout(() => { location.href = res.redirect; }, 800); }
        //       })
        //       .fail(() => {
        //           if (window.notyf) { window.notyf.error('Could not re-order. Please try again.'); }
        //       })
        //       .always(() => { $btn.removeClass('btn--loading').prop('disabled', false); });
        setTimeout(() => {
            $btn.removeClass('btn--loading').prop('disabled', false);

            if (window.notyf) {
                window.notyf.success(
                    'Items from order #' + orderId + ' have been added to your cart.'
                );
            }

            const $count = $('.cart-count');
            if ($count.length) {
                const current = parseInt($count.first().text(), 10) || 0;
                $count.text(current + 1);
            }
        }, 600);
    });
})(jQuery);
